import React, { useState, Fragment, useEffect } from 'react';
import { Form, Input, Button, Radio, DatePicker, Select, Checkbox, Row, Col, Spin } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import 'antd/dist/reset.css';
import { FormProvider, useForm } from "react-hook-form";
import { productPlans } from '../constants/paymentPlans';
import { postApi } from '../utils/apiUtils';
import '../style.css';

import Self from '../assets/icons/Self.png'
import Parents from '../assets/icons/Parents.png'
import Spouse from '../assets/icons/Spouse.png'
import Sibling from '../assets/icons/Sibling.png'
import children from '../assets/icons/children.png'
// import Input from "./Input";

import { createPaymentLink } from '../utils/easeUtils';

const { Option } = Select;


const loadScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};

const PlanAndPersonalInfo = (props) => {
    const { company, formFields, loanData } = props;
    const [form] = Form.useForm();
    const [isFormValid, setIsFormValid] = React.useState(false);
    const [loading, setLoading] = useState(false);


    const [formValues, setFormValues] = useState({
        fullName: '',
        gender: '',
        email: '',
        dateOfBirth: '',
        mobile: '',
        city: '',
        pincode: ''
    });

    const handleInputChange = (value, field) => {
        if (field === 'dateOfBirth') {
            const date = new Date(value);
            setFormValues({
                ...formValues,
                [field]: moment(date).format('YYYY-MM-DD')
            });
        }
        else {
            setFormValues({
                ...formValues,
                [field]: value
            });
        }
    };

    useEffect(() => {
        loadScript('https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js');
    }, []);
    const get_txn_id = () => {
        const uuid = uuidv4().replace(/-/g, '');
        const shortUuid = uuid.slice(0, 8);
        const timestamp = Date.now().toString();
        return `${shortUuid}${timestamp}`;
    }
    const handlePayment = async () => {
        if (loading) {
            return;
        }
        try {
            let planAmount = _.find(plans, { id: selectedPlan }).amount
            const txnId = get_txn_id();
            const _paymentData = {
                firstname: formValues.fullName,
                phone: formValues.mobile,
                email: formValues.email,
                status: "INITIATED",
                amount: planAmount,
                txnid: txnId,
                gender: formValues.gender,
                buyFor: selectedBuyer,
                dob: formValues.dateOfBirth,
                city: formValues.city,
                pincode: formValues.pincode,
                product: props.selectedProduct
            }
            const insuranceLambda = await postApi('https://6cnun4duga.execute-api.ap-south-1.amazonaws.com/dev/insurance', _paymentData);
            setLoading(true);
            const accessData = await createPaymentLink(txnId, planAmount, formValues.fullName, formValues.mobile, formValues.email)
            setLoading(false);
            if (window.EasebuzzCheckout) {
                const easebuzzCheckout = new window.EasebuzzCheckout('AWJXDQPKIG', 'prod');

                const options = {
                    access_key: accessData?.key,
                    onResponse: (response) => {
                        props.redirectToStep(response)
                    },
                    theme: '#123456', // color hex
                };

                easebuzzCheckout.initiatePayment(options);
            }
        } catch (error) {
            setLoading(false);
            throw error;
        }

    };
    const plans = productPlans[props.selectedProduct || 'product1'] || [];
    const BuyingOptions = [
        { id: 'self', label: 'Self', icon: Self },
        { id: 'spouse', label: 'Spouse', icon: Spouse },
        { id: 'parents', label: 'Parents', icon: Parents },
        { id: 'siblings', label: 'Siblings', icon: Sibling },
        { id: 'children', label: 'Children', icon: children },
    ];

    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedBuyer, setSelectedBuyer] = useState('self');

    const onFinish = (values) => {
    };

    const handlePlanSelect = (planId) => {
        setSelectedPlan(planId);

    };

    const handleBuyerSelect = (buyerId) => {
        setSelectedBuyer(buyerId);
    };
    let fieldsState = {};
    let partnerFields = [];
    if (formFields && company) {
        partnerFields = formFields[company]?.filter(
            (field) => field?.page === "personal-details"
        );
        partnerFields?.forEach((field) => {
            if (!loanData) {
                return
            }
            return (fieldsState[field.name] = loanData[field.name] || "");
        });
    }
    const handleGoBack = (e) => {
        e.preventDefault();
        props.goToPrevStep();
    };
    const formRef = useForm(fieldsState);
    const {
        reset,
        handleSubmit,
        trigger,
        // Read the formState before render to subscribe the form state through the Proxy
        formState: { isDirty, isValid },
    } = formRef;

    const redirectToLoanDetailsPage = handleSubmit((data) => {
        props?.redirectToStep(data);
    });

    useEffect(() => {
        setTimeout(() => {
            reset(
                {
                    ...fieldsState,
                },
                { keepDefaultValues: true }
            );
            trigger();
        }, 0);
    }, []);

    return (
        <>
            <Form onFinish={handlePayment} className="insurance-form" form={form} >
                <h1 style={{ fontWeight: 'bold', fontSize: '1.4em' }}>Choose your 1-year plan and pay</h1>
                <p style={{ color: 'grey', fontSize: '1.2em' }}>Daily Protection</p>
                <div className="plans-container">
                    {plans.map((plan) => (
                        <Radio.Group
                            key={plan.id}
                            value={selectedPlan}
                            onChange={() => handlePlanSelect(plan.id)}
                            className={`plan-tile ${selectedPlan === plan.id ? 'selected' : ''}`}
                        >
                            <Radio value={plan.id}>
                                <div className="plan-details">
                                    <h3>{plan.name}</h3>
                                    <p className="current-price">{plan.originalPrice}</p>
                                    <p className="original-price">{plan.currentPrice}</p>
                                </div>
                            </Radio>
                        </Radio.Group>
                    ))}
                </div>

                <h3>Buying for</h3>
                <Form.Item
                    name="buyer"
                    rules={[{ required: true, message: 'Please select who you are buying for' }]}
                >
                    <Select
                        placeholder="Select who you are buying for"
                        onChange={handleBuyerSelect}
                        value={selectedBuyer}
                    >
                        {BuyingOptions.map((option) => (
                            <Option key={option.id} value={option.id}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item name="fullName" rules={[{ required: true, message: 'Please enter your full name' }]}>
                    <Input placeholder="Full Name" onChange={(e) => handleInputChange(e.target.value, 'fullName')} />
                </Form.Item>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="gender" rules={[{ required: true, message: 'Please select your gender' }]}>
                            <Select placeholder="Select Gender" onChange={(value) => handleInputChange(value, 'gender')}>
                                <Option value="male">Male</Option>
                                <Option value="female">Female</Option>
                                <Option value="other">Other</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="dateOfBirth" rules={[{ required: true, message: 'Please select your date of birth' }]}>
                            <DatePicker placeholder="Date of Birth" style={{ width: '100%' }} onChange={(value) => handleInputChange(value, 'dateOfBirth')} />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item name="email" rules={[{ required: true, message: 'Please enter your email address' }, { type: 'email', message: 'Please enter a valid email address' }]}>
                    <Input placeholder="Email Address" onChange={(e) => handleInputChange(e.target.value, 'email')} />
                </Form.Item>
                <Form.Item name="mobile" rules={[{ required: true, message: 'Please enter your mobile number' }]}>
                    <Input placeholder="Mobile Number" onChange={(e) => handleInputChange(e.target.value, 'mobile')} />
                </Form.Item>
                <Form.Item name="city" rules={[{ required: true, message: 'Please enter your city' }]}>
                    <Input placeholder="City" onChange={(e) => handleInputChange(e.target.value, 'city')} />
                </Form.Item>
                <Form.Item name="pincode" rules={[{ required: true, message: 'Please enter your pincode' }]}>
                    <Input placeholder="Pincode" onChange={(e) => handleInputChange(e.target.value, 'pincode')} />
                </Form.Item>
                <Form.Item name="declaration" valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject('Please accept the declaration') }]}>
                    <Checkbox>
                        I hereby declare that I and all proposed members are in good health and entirely free from any mental or physical impairments or deformities, disease/condition. Also, none of the proposed member are habitual consumer of alcohol, tobacco, gutka or any recreational drugs. I also agree to <a href="#" onClick={(e) => {
                            e.preventDefault();
                            window.open('https://drive.google.com/file/d/1XeKEIqVQYlNuEP0CCKozddu9ZrOiJg3P/view', '_blank', 'noopener,noreferrer');
                        }}> T&Cs </a>
                    </Checkbox>
                </Form.Item>
                <Form.Item style={{ textAlign: 'center' }}>
                    <Button type="primary" htmlType="submit" style={{ width: '100%', backgroundColor : '#5A786F' }} disabled={loading}>
                        Proceed To Payment
                    </Button>
                    {loading && <Spin tip="Loading..." style={{ marginTop: '10px' }} />}
                    <Button type="primary" onClick={handleGoBack} style={{ width: '100%', marginTop: 20, backgroundColor : '#5A786F' }}>
                        Go Back
                    </Button>
                </Form.Item>
            </Form>
        </>
    );

};
export default PlanAndPersonalInfo;
